/**
 * Activity tracking — NO-OP in this build.
 *
 * The source app reported per-app activity to a backend. This portfolio has no
 * backend, so the provider is a transparent passthrough and the tracking hook
 * returns inert values. Kept at the original import path so `Window` (and any
 * future consumer) compiles unchanged.
 */
import type { ReactNode } from "react";

export interface ActivityContextValue {
  /** Record an activity event (no-op). */
  track: (event?: string) => void;
}

const INERT: ActivityContextValue = { track: () => {} };

/** Passthrough provider — renders children, tracks nothing. */
export function ActivityTrackingProvider({
  children,
}: {
  appId: string;
  children: ReactNode;
}) {
  return <>{children}</>;
}

/** Returns an inert tracker. */
export function useTrackActivity(): ActivityContextValue {
  return INERT;
}
